export default "__VITE_ASSET__bac8161b__"